import { Box } from '@mui/material'

export default function PageContent ({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {children}
    </Box>
  )
}
